"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidestepStrategy = exports.SidestepMode = void 0;
var SidestepMode;
(function (SidestepMode) {
    SidestepMode["DISABLED"] = "DISABLED";
    SidestepMode["AUTO"] = "AUTO";
})(SidestepMode || (exports.SidestepMode = SidestepMode = {}));
var SidestepStrategy;
(function (SidestepStrategy) {
    SidestepStrategy["AWAY_FROM_BALL"] = "AWAY_FROM_BALL";
    SidestepStrategy["TOWARD_BALL"] = "TOWARD_BALL";
    SidestepStrategy["AWAY_FROM_THREAT"] = "AWAY_FROM_THREAT";
    SidestepStrategy["MARK"] = "MARK";
    SidestepStrategy["TOWARD_SIDELINE"] = "TOWARD_SIDELINE";
    SidestepStrategy["AWAY_FROM_SIDELINE"] = "AWAY_FROM_SIDELINE";
    SidestepStrategy["TOWARD_ENDZONE"] = "TOWARD_ENDZONE";
    SidestepStrategy["RANDOM"] = "RANDOM";
    SidestepStrategy["CUSTOM"] = "CUSTOM";
})(SidestepStrategy || (exports.SidestepStrategy = SidestepStrategy = {}));
